import React, { useRef, useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import PauseIcon from '@mui/icons-material/Pause';

interface UserProfileHeaderProps {
  name: string;
  accentName?: string;
  previewUrl?: string;
  setUserProfileIcon?: any;
}

const UserProfileHeader: React.FC<UserProfileHeaderProps> = ({
  name,
  accentName,
  previewUrl,
  setUserProfileIcon
}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPreview = () => {
    if (!previewUrl) return;
    if (!audioRef.current) {
      audioRef.current = new Audio(previewUrl);
      audioRef.current.onended = () => setIsPlaying(false);
    }
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#2d3b5e",
        borderRadius: "8px",
        padding: "12px 16px",
        maxWidth: "400px",
        width: "100%",
        position: "relative",
        height: '66px'
      }}
    >
      <IconButton
        sx={{
          position: "absolute",
          top: "-10px",
          right: "-10px",
        }}
        onClick={()=>setUserProfileIcon(true)}
      >
        <CloseIcon />
      </IconButton>
      {/* Left side - Name and Accent */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <Typography
          sx={{
            color: "#ffffff",
            fontSize: "18px",
            fontWeight: 500,
            lineHeight: 1.2,
          }}
        >
          {name}
        </Typography>
        {accentName && (
          <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {/* India Flag */}
            <Box
              sx={{
                width: "20px",
                height: "14px",
                borderRadius: "2px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box sx={{ flex: 1, backgroundColor: "#FF9933" }} />
              <Box sx={{ flex: 1, backgroundColor: "#FFFFFF" }} />
              <Box sx={{ flex: 1, backgroundColor: "#138808" }} />
            </Box>
            <Typography
              sx={{
                color: "#b8c5d6",
                fontSize: "14px",
                fontWeight: 400,
              }}
            >
              {accentName}
            </Typography>
          </Box>
        )}
      </Box>

      {/* Right side - Play/Pause Button */}
      {previewUrl && (
        <Box
          onClick={handlePlayPreview}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "transform 0.2s",
            "&:hover": {
              transform: "scale(1.1)",
            },
          }}
        >
          {isPlaying ? (
            <PauseIcon sx={{ color: "#ffffff", fontSize: "20px" }} />
          ) : (
            <PlayCircleOutlineIcon sx={{ color: "#ffffff", fontSize: "20px" }} />
          )}
        </Box>
      )}
    </Box>
  );
};

export default UserProfileHeader;
